exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SelectContent__mobileContent___19Y8x div[class*=\"ant-select-selection-selected-value\"] {\n  color: black; }\n\n.SelectContent__desktopSelect___158Ss div[class*=\"ant-select-selection--multiple\"] {\n  overflow: auto; }\n", ""]);

// exports
exports.locals = {
	"mobileContent": "SelectContent__mobileContent___19Y8x",
	"desktopSelect": "SelectContent__desktopSelect___158Ss"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/MultiSelector/SelectContent/SelectContent.scss
// module id = 2134
// module chunks = 6